// extracted by mini-css-extract-plugin
module.exports = {"card":"contractAdditionalInfoList_card__2753v"};